var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaign",
    clipPath: "url(#clip0_3148_13900)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.41896 4.23036L1.913 5.16978C0.948866 5.42812 0.35862 6.38065 0.601346 7.28651L1.04267 8.93354C1.28539 9.83941 2.27282 10.3692 3.23696 10.1109L4.11345 9.87601L5.07738 13.4735C5.19875 13.9264 5.69246 14.1913 6.17453 14.0621C6.6566 13.9329 6.95172 13.4567 6.83036 13.0038L5.86643 9.4063L6.74291 9.17144L10.9584 10.2547C11.329 10.3499 11.6649 10.0106 11.5658 9.64103L9.36093 1.41223C9.2619 1.04265 8.80138 0.916714 8.52806 1.18447L5.41896 4.23036ZM12.6546 4.93949C12.3611 3.84422 11.588 2.99222 10.6007 2.533L12.0769 8.04231C12.7045 7.1592 12.9481 6.03477 12.6546 4.93949Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3148_13900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.d869cb76e03f512d746b7a152868b13e.svg";
export { ForwardRef as ReactComponent };